export const inputBase =
  "w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm shadow-sm " +
  "placeholder:text-slate-400 focus:outline-none focus:ring-2 " +
  "focus:ring-indigo-200 focus:border-indigo-500";

export const labelBase = "text-sm font-medium text-slate-900";
